import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Teams from '../Teams/Teams';

const Home = () => {
    return (
        <div>
            <Header />
            <Teams />
            <Footer />
        </div>
    );
};

export default Home;